<div class="g-layout__container">
    <div>
        <div class="g-c-primary-darker text-xl my-3 font-bold">
            {{'control_panel' | translate}}
        </div>
        <div class="br"></div>
    </div>

    <div class="mt-5 grid gap-4">
        <div [routerLink]="['/admin/department']" class="col-5      shadow-4     cursor-pointer  border-round-lg p-3">
            <div class="flex gap-4  flex-column align-items-center">
                <div class="font-bold g-c-gray-300">
                    {{'departments_and_sections' | translate}}
                </div>
                <div>
                    <i class="fa-solid fa-sitemap g-c-primary" style="font-size: 4rem;"></i>
                </div>
            </div>
        </div>


        <div [routerLink]=" ['/admin/permission']" class="col-5  shadow-4  cursor-pointer  border-round-lg p-3">
            <div class="flex gap-4  flex-column align-items-center">
                <div class="font-bold  g-c-gray-300">
                    {{'users' | translate}}
                </div>
                <div>
                    <i class="fa-solid fa-users g-c-primary" style="font-size: 4rem;"></i>
                </div>
            </div>
        </div>

    </div>

</div>